/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Own_Bot_FailedInputs */



/**
* | output |
* | --- |
* | "The move didn't go through." |
*
* @param {Settings_Own_Bot_FailedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const settings_own_bot_failed = /** @type {((inputs?: Settings_Own_Bot_FailedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Own_Bot_FailedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти не удалось.")
	return /** @type {LocalizedString} */ ("The move didn't go through.")
});